import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function ForWhoSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16 md:py-24" data-id="element-53">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-54">
        <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-10" data-id="element-55">
          Para quién es (y para quién no)
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-56">
          <motion.div variants={itemVariants} className="bg-[#141414] p-6 md:p-8 rounded-lg border border-[#2A2A2A]" data-id="element-57">
            <p className="text-[#E8732A] font-bold text-lg mb-6" data-id="element-58">
              Esto es para ti si:
            </p>
            <div className="space-y-4" data-id="element-59">
              <div className="flex items-start gap-3" data-id="element-60">
                <CheckIcon className="w-5 h-5 text-[#E8732A] flex-shrink-0 mt-1" data-id="element-61" />
                <p className="text-[#A0A0A0]" data-id="element-62">
                  ya publicas contenido (o lo estás empezando)
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-63">
                <CheckIcon className="w-5 h-5 text-[#E8732A] flex-shrink-0 mt-1" data-id="element-64" />
                <p className="text-[#A0A0A0]" data-id="element-65">haces afiliados (mixto)</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-66">
                <CheckIcon className="w-5 h-5 text-[#E8732A] flex-shrink-0 mt-1" data-id="element-67" />
                <p className="text-[#A0A0A0]" data-id="element-68">promocionas cursos/educación</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-69">
                <CheckIcon className="w-5 h-5 text-[#E8732A] flex-shrink-0 mt-1" data-id="element-70" />
                <p className="text-[#A0A0A0]" data-id="element-71">
                  quieres ventas sin sonar desesperado
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#141414] p-6 md:p-8 rounded-lg border border-[#2A2A2A]" data-id="element-72">
            <p className="text-white/60 font-bold text-lg mb-6" data-id="element-73">
              No es para ti si:
            </p>
            <div className="space-y-4" data-id="element-74">
              <div className="flex items-start gap-3" data-id="element-75">
                <XIcon className="w-5 h-5 text-white/40 flex-shrink-0 mt-1" data-id="element-76" />
                <p className="text-[#A0A0A0]/70" data-id="element-77">buscas "dinero garantizado"</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-78">
                <XIcon className="w-5 h-5 text-white/40 flex-shrink-0 mt-1" data-id="element-79" />
                <p className="text-[#A0A0A0]/70" data-id="element-80">
                  odias medir aunque sea lo mínimo
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-81">
                <XIcon className="w-5 h-5 text-white/40 flex-shrink-0 mt-1" data-id="element-82" />
                <p className="text-[#A0A0A0]/70" data-id="element-83">
                  quieres un sistema que funcione sin hablar con nadie (aquí el
                  DM es clave)
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}